import './styles.scss';

export default {
    name: 'FixtureListItem',

    props: {
        id: String
    },

    computed: {
        item() {
            return this.$store.getters.getFixtureByType(this.id);
        }
    },

    methods: {
        clicked() {
            this.$emit('clicked', '/action/operations/fixtures/' + this.item.id);
        }
    }
};